import React from "react";

const AchivementArea = () => {
  return (
    <section
      className="pt-5 pb-5"
      style={{
        background: "#ffffff",
        position: "relative",
        zIndex: 0,
      }}
    >
      <style>{`
        .impact-section {
          max-width: 1100px;
          margin: 0 auto;
        }
        .impact-heading {
          text-align: center;
          margin-bottom: 3rem;
        }
        .impact-heading h2 {
          font-size: 2.4rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 0.75rem;
        }
        .impact-heading p {
          color: #666;
          font-size: 1.1rem;
          max-width: 650px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .impact-cards {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 40px;
        }

        /* Card – invisible by default, appears on hover */
        .impact-card {
          text-align: center;
          flex: 1 1 200px;
          max-width: 220px;
          padding: 20px 10px;
          border-radius: 20px;
          background: transparent;
          box-shadow: none;
          transition: background 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
          cursor: default;
        }
        .impact-card:hover {
          background: #ffffff;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
          transform: translateY(-6px);
        }

        .impact-card .icon-wrapper {
          width: 90px;
          height: 90px;
          margin: 0 auto 1.5rem;
          background: #0a1a3d;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(10, 26, 61, 0.15);
        }
        .impact-card .icon-wrapper img {
          width: 45px;
          height: 45px;
        }

        .impact-card .number {
          font-size: 3rem;
          font-weight: 800;
          color: #e86b24;
          line-height: 1;
          margin-bottom: 0.5rem;
        }
        .impact-card .label {
          font-size: 1.1rem;
          color: #333;
          font-weight: 600;
          letter-spacing: 0.3px;
        }

        @media (max-width: 768px) {
          .impact-heading h2 {
            font-size: 2rem;
          }
          .impact-cards {
            gap: 30px;
          }
          .impact-card {
            max-width: 160px;
          }
        }
      `}</style>

      <div className="container impact-section">
        <div className="impact-heading">
          <h2>Our Impact in Numbers</h2>
          <p>
            Trusted by families and investors alike, we’ve built a reputation
            for quality, transparency, and on‑time delivery.
          </p>
        </div>

        <div className="impact-cards">
          <div className="impact-card">
            <div className="icon-wrapper">
              <img src="assets/img/update1/icon/achive_1_1.svg" alt="Estates" />
            </div>
            <div className="number">18+</div>
            <div className="label">Estates</div>
          </div>

          <div className="impact-card">
            <div className="icon-wrapper">
              <img src="assets/img/update1/icon/achive_1_2.svg" alt="Clients" />
            </div>
            <div className="number">126+</div>
            <div className="label">Happy Clients</div>
          </div>

          <div className="impact-card">
            <div className="icon-wrapper">
              <img src="assets/img/update1/icon/achive_1_3.svg" alt="Professionals" />
            </div>
            <div className="number">89+</div>
            <div className="label">Professionals</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchivementArea;